import { render, staticRenderFns } from "./TripDestinationsSelect.vue?vue&type=template&id=6ed63e1a"
import script from "./TripDestinationsSelect.vue?vue&type=script&lang=ts"
export * from "./TripDestinationsSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports